module.exports = __webpack_public_path__ + "046a93690f81c2fcb5592ae4e8cc805f.pdf";